<template>
	<div class="" >
		<el-dialog title="" @close="close" :visible.sync="visible" :close-on-click-modal="false" width="50%" center>
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
				<el-form-item :label="title" prop="desc">
					<el-input type="textarea" v-model="ruleForm.desc"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button @click="close()">{{langInfo.cancel}}</el-button>
					<el-button type="primary" @click="submitForm('ruleForm')">{{langInfo.submit}}</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		props: {
			askVisible: {
				type: Boolean,
				default: false,
			},
			id: {
				type: [String, Number],
				default: 0,
			},
			course_subject_id: {
				type: [String, Number],
				default: 0,
			},
			title: {
				type: String,
				default: '',
			},
			order_item_id: {
				type: [String, Number],
				default: 0,
			},
			question_question_id: {
				type: [String, Number],
				default: 0,
			},
		},
		watch: {
			// 监视message属性的变化
			askVisible: function(newVal, oldVal) {
				console.log('videoVisible changed from', oldVal, 'to', newVal);
				this.visible = newVal
			},
		},

		data() {
			return {
				visible: false,
				ruleForm: {
					desc: ''
				},
				rules: {
					desc: [
						{ required: true, message: '', trigger: 'blur' } //请输入内容
					]
				},
				langInfo: {}
			}
		},
		created() {
			this.langInfo = this.$store.getters['lang/getLangList']
			if (this.langInfo.length == 0) {
				this.getdict_data()
			} else {
				this.rules.desc[0].message = this.langInfo.phone_content_tip
			}
		},
		methods: {
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langInfo = obj
					this.rules.desc[0].message = this.langInfo.phone_content_tip
					this.$store.dispatch('lang/setLangList', obj)
				}).catch((error) => {})
			},
			submitForm(formName) {
				var that = this
				this.$refs[formName].validate((valid) => {
					if (valid) {
						// content=内容
						// course_question_id=题目id
						// type=0是提问1是回复
						// question_question_id=如果是回复的话 传这个字段(被回复问题的id)


						let param = {

						}
						if (this.question_question_id > 0) {
							// 追问
							param = {
								content: this.ruleForm.desc,
								type: 0,
								course_question_id: this.id,
								course_subject_id: this.course_subject_id,
								question_question_id: this.question_question_id,
								order_item_id: this.order_item_id,
							}
						} else {
							param = {
								content: this.ruleForm.desc,
								type: 0,
								course_question_id: this.id,
								course_subject_id: this.course_subject_id,
								order_item_id: this.order_item_id
							}
						}

						that.$api.addQuestionCorrection(param).then((res) => {
							console.log(res);
							// status=0 0是取消1是收藏成功
							this.$message({
								message: res.msg,
								type: 'success'
							})
						}).catch((error) => {
							this.$message({
								message: error.msg,
								type: 'warning'
							})
						})


						setTimeout(() => {
							this.visible = false
							this.ruleForm.desc = ""
							this.$emit('close')
						}, 800)


					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			close() {
				this.visible = false
				this.ruleForm.desc = ""
				this.$emit('close')
			},
		}
	}
</script>

<style>
</style>